// redux/store.jsx

import { configureStore } from "@reduxjs/toolkit";
import filterReducer from "./filterState";

export const store = configureStore({
  reducer: {
    filters: filterReducer
  }
});

export default store;
